import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, ViewChild, Output, EventEmitter, SimpleChanges, OnInit, OnDestroy } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { BaseService, LanguageService, TreeService } from '@shared/services';
import { MatSort } from '@angular/material/sort';
import { first, takeUntil, tap } from 'rxjs/operators';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { ResourcesService } from '@shared/services/resources.service';
import { Input } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

export class TodoItemNode {
    childs: TodoItemNode[];
    resourceCategoryName: string;
    resourceCategoryId: string;
}

/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode {
    item: string;
    id: string;
    level: number;
    expandable: boolean;
    childs: TodoItemNode[];
}
/**
 * @title Tree with flat nodes
 */
@Component({
    selector: 'app-search-categories-checkbox-tree',
    templateUrl: './search-categories-checkbox-tree.component.html',
    styleUrls: ['./search-categories-checkbox-tree.component.scss']
})
export class SearchCategoriesTreeComponent implements OnInit, OnDestroy {
    private _unsubscribeAll$ = new Subject<boolean>();

    allCategories = [];
    relatedResourcesFromCurrentSelected = [];
    constructor(
        public router: Router,
        private langservice: LanguageService,
        private _treeService: TreeService,
        private _resourceService: ResourcesService,
        private baseService: BaseService
    ) {
        if (this.IsRole == true || this.isForReports == true) {
            this.currSelectedRess = [];
            this.selection = new SelectionModel(true);
            this.selectedResource = new EventEmitter<any>();
            this.selectedResources = new EventEmitter<any>();
        }
        this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
        this.treeControl = new FlatTreeControl<TodoItemFlatNode>(this.getLevel, this.isExpandable);
        this.dataSourceTree = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
        this._treeService
            .getTreeCategory()
            .pipe(takeUntil(this._unsubscribeAll$))
            .subscribe((result) => {
                this.dataSourceTree.data = result.data;
                this.loaded = true;
                if (this.resourcesLoaded) this.preCheckNode();
            });
    }

    flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();
    nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();
    selectedParent: TodoItemFlatNode | null = null;
    newItemName = '';
    treeControl: FlatTreeControl<TodoItemFlatNode>;

    treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;
    loaded = false;
    resourcesLoaded = false;

    dataSourceTree: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;
    checklistSelection = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
    getLevel = (node: TodoItemFlatNode) => node.level;

    isExpandable = (node: TodoItemFlatNode) => node.expandable;

    getChildren = (node: TodoItemNode): TodoItemNode[] => node.childs;

    hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;

    hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.item === '';

    /**
     * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
     */
    transformer = (node: TodoItemNode, level: number) => {
        const existingNode = this.nestedNodeMap.get(node);
        const flatNode =
            existingNode && existingNode.item === node.resourceCategoryName ? existingNode : new TodoItemFlatNode();
        flatNode.item = node.resourceCategoryName;
        flatNode.id = node.resourceCategoryId;
        flatNode.level = level;
        flatNode.expandable = !!node.childs?.length;
        flatNode.childs = node.childs;
        this.flatNodeMap.set(flatNode, node);
        this.nestedNodeMap.set(node, flatNode);
        return flatNode;
    };
    // makeDisabledIfCheckParent(node: TodoItemFlatNode) {
    //     console.log(node);
    //     console.log(this.checklistSelection.selected);
    //     // debugger;
    //     // const isSelected = this.checklistSelection.isSelected(node);
    //     // console.log(isSelected);
    //     const item = this.checklistSelection.selected.find((category) => node.id === category.id);
    //     if (node.level > 0) return true;
    // }
    /** Whether all the descendants of the node are selected. */
    descendantsAllSelected(node: TodoItemFlatNode): boolean {
        const descendants = this.treeControl.getDescendants(node);
        const descAllSelected =
            descendants.length > 0 &&
            descendants.every((child) => {
                return this.checklistSelection.isSelected(child);
            });
        return descAllSelected;
    }

    /** Whether part of the descendants are selected */
    descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
        const descendants = this.treeControl.getDescendants(node);
        const result = descendants.some((child) => this.checklistSelection.isSelected(child));
        return result && !this.descendantsAllSelected(node);
    }

    descendantsPartiallySelectedAndNotChecked(node: TodoItemFlatNode) {
        const descendants = this.treeControl.getDescendants(node);
        const result = descendants.some((child) => this.checklistSelection.isSelected(child));
        const checkedResult = this.checkIsSelected(node);
        return result && !checkedResult;
    }

    /** Toggle the to-do item selection. Select/deselect all the descendants node */
    todoItemSelectionToggle(node: TodoItemFlatNode): void {
        this.selection.clear();
        this.checklistSelection.toggle(node);
        const descendants = this.treeControl.getDescendants(node);
        this.checklistSelection.isSelected(node)
            ? this.checklistSelection.select(...descendants)
            : this.checklistSelection.deselect(...descendants);

        // Force update for the parent
        descendants.forEach((child) => this.checklistSelection.isSelected(child));
        // this.checkAllParentsSelection(node);
        this.tableData.data = [];
        this.allData = [];
        if (this.checklistSelection?.selected?.length > 0) {
            this.getResourcesByCategories(this.checklistSelection?.selected);
        }
    }

    private getResourcesByCategories(array) {
        array.forEach((category) => {
            const categoryResources = this.allCategories.filter((categoryItem) => {
                return categoryItem.resourceCategoryid === category.id;
            });
            this.allData.push(...categoryResources);
            this.tableData = new MatTableDataSource(this.allData);
            this.selectedCategories.emit(this.checklistSelection.selected);

            this.tableData.data.forEach((row) => {
                if (this.isForReports) this.selection.select(row);
            });

            if (
                this.rememberSelection &&
                this.tableData.data &&
                this.tableData.data.length > 0 &&
                this.currSelectedRess &&
                this.currSelectedRess.length > 0
            ) {
                this.currSelectedRess.forEach((r) => {
                    this.tableData.data.forEach((row) => {
                        if (r.resourceId == row.resourceId) this.selection.select(row);
                    });
                });
            }
        });
    }
    private getResourcesByCategoriesAndSelectCurrent(array) {
        array.forEach((category) => {
            const categoryResources = this.allCategories.filter((categoryItem) => {
                return categoryItem.resourceCategoryid === category.id;
            });

            this.allData.push(...categoryResources);
            this.tableData = new MatTableDataSource(this.allData);
        });

        this.relatedResourcesFromCurrentSelected.forEach((r) => {
            this.tableData.data.forEach((row) => {
                if (r.resourceId == row.resourceId) this.selection.select(row);
            });
        });
    }
    /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
    todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
        this.selection.clear();
        this.checklistSelection.toggle(node);
        // this.checkAllParentsSelection(node);
        // console.log(this.checklistSelection.selected);
        this.tableData.data = [];
        this.allData = [];
        if (this.checklistSelection?.selected?.length > 0) {
            this.getResourcesByCategories(this.checklistSelection?.selected);
        }
    }

    getresbycatid(id) {
        this.tableLoaded = false;
        this._resourceService
            .getresourcesbycatid(id)
            .pipe(
                takeUntil(this._unsubscribeAll$),
                first(),
                tap((result) => {
                    this.tableLoaded = false;
                    // this.tableData = new MatTableDataSource(result.data);
                    this.allData.push(...result.data);
                    // this.tableData.data = this.allData;
                    this.tableData = new MatTableDataSource(this.allData);

                    if (
                        this.rememberSelection &&
                        this.tableData.data &&
                        this.tableData.data.length > 0 &&
                        this.currSelectedRess &&
                        this.currSelectedRess.length > 0
                    ) {
                        this.currSelectedRess.forEach((r) => {
                            this.tableData.data.forEach((row) => {
                                if (r.resourceId == row.resourceId) this.selection.select(row);

                                if (this.isForReports) this.selection.select(row);
                            });
                        });
                    }
                    if (result.isSuccess) this.tableLoaded = true;
                })
            )
            .subscribe();
    }

    /* Checks all the parents when a leaf node is selected/unselected */
    checkAllParentsSelection(node: TodoItemFlatNode): void {
        let parent: TodoItemFlatNode | null = this.getParentNode(node);
        while (parent) {
            this.checkRootNodeSelection(parent);
            parent = this.getParentNode(parent);
        }
    }

    /** Check root node checked state and change it accordingly */
    checkRootNodeSelection(node: TodoItemFlatNode): void {
        const nodeSelected = this.checklistSelection.isSelected(node);
        const descendants = this.treeControl.getDescendants(node);
        const descAllSelected =
            descendants.length > 0 &&
            descendants.every((child) => {
                return this.checklistSelection.isSelected(child);
            });
        if (nodeSelected && !descAllSelected) {
            this.checklistSelection.deselect(node);
        } else if (!nodeSelected && descAllSelected) {
            this.checklistSelection.select(node);
        }
    }

    /* Get the parent node of a node */
    getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
        const currentLevel = this.getLevel(node);

        if (currentLevel < 1) {
            return null;
        }

        const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

        for (let i = startIndex; i >= 0; i--) {
            const currentNode = this.treeControl.dataNodes[i];

            if (this.getLevel(currentNode) < currentLevel) {
                return currentNode;
            }
        }
        return null;
    }

    checkIsSelected(node: TodoItemFlatNode) {
        return this.checklistSelection.selected.findIndex((x) => x.id === node.id) > -1 ? true : false;
    }
    checkItemInList(list, item, attr) {
        if (list.find((x) => x[attr] === item)) {
            return list.find((x) => x[attr] === item);
        } else {
            return false;
        }
    }

    dbselectresource(row) {
        this.selectedResource.emit(row);
        this.activeStyleUserTable = row.resourceId;
        this.IsDbClickAction.emit(true);

        // this.selection = row;
    }
    activeStyleNode = '';
    TREE_DATA: any;

    @Output('IsDbClickAction')
    IsDbClickAction: EventEmitter<any> = new EventEmitter<any>();

    @Output('selectedCategories')
    selectedCategories: EventEmitter<any> = new EventEmitter<any>();

    @Input('savedCategories')
    savedCategories;

    @Input('EnableDoubleClickSelection')
    EnableDoubleClickSelection: false;
    @Input('canEdit')
    canEdit = true;

    @Input('RoleResourceList')
    RoleResourceList = [];

    @Input('IsRole')
    IsRole = false;

    @Input('rememberSelection')
    rememberSelection = false;

    @Input('isForReports')
    isForReports = false;

    @Input('multiselect')
    multiselect = true;
    @Output('selectedResource')
    selectedResource: EventEmitter<any> = new EventEmitter<any>();

    @Output('selectedResources')
    selectedResources: EventEmitter<any> = new EventEmitter<any>();

    @Input('currSelectedRess')
    currSelectedRess = [];
    @Input('FixedTimeList')
    FixedTimeList = null;
    @Input('IsFixedTime')
    IsFixedTime = false;

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    displayedColumns: string[] = ['select', 'addToFav', 'resourceName', 'locationName'];
    tableData = new MatTableDataSource([]);
    selection = new SelectionModel(true, []);

    activeStyleUserTable = '';
    selectedCat = '';

    // getTreeCategory() {
    //     this._treeService
    //         .getTreeCategory()
    //         .pipe(takeUntil(this._unsubscribeAll$), first())
    //         .subscribe((result) => {
    //             console.log(result.data);
    //             this.dataSource.data = result.data;
    //         });
    // }

    IsRoleResource(tableElment) {
        if (this.IsRole && this.RoleResourceList.length > 0) {
            this.RoleResourceList.forEach((r) => {
                this.tableData.data.forEach((row) => {
                    if (r.resourceid == row.resourceId) {
                        row.accessType = r.accessType;
                        this.selection.select(row);
                    }
                });
            });
            var check = this.RoleResourceList.find((e) => e.resourceid == tableElment.resourceId);

            if (check) {
                return true;
            }
            return false;
        }
        return false;
    }
    setStyle(addTofav) {
        return { color: 'black' };
    }
    AddToFav(row) {
        var favRes = { resourceId: row.resourceId };
        var fav = [];
        if (row.addToFav != true) {
            this._resourceService
                .AddToFav(favRes)
                .pipe(takeUntil(this._unsubscribeAll$), first())
                .subscribe((result) => {
                    if (result.data != null) {
                        row.addToFav = true;
                        this.getFavList();
                    }
                });
        } else {
            fav.push(favRes);
            this._resourceService
                .RemoveFromFav(fav)
                .pipe(takeUntil(this._unsubscribeAll$), first())
                .subscribe((result) => {
                    if (result) {
                        row.addToFav = false;
                        this.getFavList();
                    }
                });
        }
    }
    getFavList() {
        this._resourceService
            .getFavList()
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                if (result.data != null) {
                    if (result.data.length != 0)
                        localStorage.setItem('lastSelectedResources', JSON.stringify(result.data));
                }
            });
    }
    accessType = [
        { value: '2', accessType: 'Add' },
        { value: '3', accessType: 'Edit' },
        { value: '5', accessType: 'Delete' }
    ];
    ngOnInit() {
        this.baseService
            .get('Asset/GetResources-byCategory?isAll=true&timeSlotType=Open')
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                if (result.isSuccess) this.allCategories = result.data;
                this.resourcesLoaded = true;
                if (this.loaded) this.preCheckNode();
                // if (this.savedCategories?.length > 0) {
                //     this.getResourcesByCategories(this.savedCategories);
                // }
            });
        if (this.IsRole) {
            // this.getAccessTypes();
            //  this.rememberSelection=false
            this.displayedColumns = ['select', 'resourceName', 'locationName', 'accesstype'];
        }

        if (this.isForReports) {
            this.displayedColumns = ['select', 'resourceName', 'locationName'];
        }
        // this.getTreeCategory();
        this.selection.changed.next = (val) => {
            if (this.IsRole == true) {
                this.selection.selected.forEach((element) => {
                    var check = this.RoleResourceList.find((e) => e.resourceid == element.resourceId);
                    if (check) {
                        if (check.accessType == '8') element.accessTypeList = ['2', '3', '5'];
                        else if (check.accessType == '7') {
                            element.accessTypeList = ['3', '5'];
                        } else if (check.accessType == '6') {
                            element.accessTypeList = ['2', '5'];
                        } else if (check.accessType == '4') {
                            element.accessTypeList = ['2', '3'];
                        } else {
                            if (check.accessType != '1') element.accessTypeList = [check.accessType];
                        }
                    } else {
                        if (element.accessType == null) {
                            element.accessType = '1';
                        }
                    }
                });
            }

            this.selectedResources.emit(val);
        };
    }

    applyAccessType(element, event) {
        if (event.length == 1) element.accessType = event[0];
        if (event.length == 3) element.accessType = '8';

        if (event.length == 2) {
            if (event.find((e) => e == '2') && event.find((e) => e == '3')) {
                element.accessType = '4';
            }
            if (event.find((e) => e == '2') && event.find((e) => e == '5')) {
                element.accessType = '6';
            }
            if (event.find((e) => e == '3') && event.find((e) => e == '5')) {
                element.accessType = '7';
            }
        }
    }
    getAccessTypes() {
        this.langservice
            .GetLookupbyKey('ResourceAccessType')
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                this.accessType = result.data;
            });
    }
    ngOnChanges(changes: SimpleChanges) {
        if (this.isForReports) {
            if (changes['currSelectedRess']) {
                if (changes.currSelectedRess.currentValue.length < 1) {
                    this.selection.clear();
                    this.checklistSelection.clear();
                }
                this.relatedResourcesFromCurrentSelected = changes.currSelectedRess.currentValue.filter((resource) => {
                    if (resource?.resourceCategoryid) return { ...resource };
                });
            }
        } else {
            if (!this.multiselect) {
                this.displayedColumns.splice(0, 1);
            }
        }
    }
    reloadafterdeletion() {
        this.selection = new SelectionModel(true, []);
        this.tableData = new MatTableDataSource();
        // this.getTreeCategory();
        if (this.selectedCat !== '') {
            this.getresbycatid(this.selectedCat);
        } else {
            this.tableData = new MatTableDataSource();
        }
    }
    getselectedResources() {
        this.selectedResource.emit(this.selection.selected);
    }
    selectresource(row) {
        this.activeStyleUserTable = row.resourceId;
        //this.selection = row;
        this.selectedResource.emit(row);
    }
    // nodeClick(node) {
    //     debugger;
    //     this.activeStyleNode = node.id;
    //     this.selectedCat = node.id;
    //     this.getresbycatid(node.id);
    //     console.log(node);
    // }
    allData = [];
    tableLoaded = true;

    editResource(row) {
        if (this.canEdit) this.router.navigate(['resource', row.resourceId]);
    }
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.tableData.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.tableData.data.forEach((row) => this.selection.select(row));
        // this.selectedResource.emit(this.selection.selected);
    }

    checkboxLabel(row): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.email + 1}`;
    }
    CheckExist(Id) {
        if (!this.FixedTimeList) {
            return false;
        }
        const findBooking = (element) => element.resourceId == Id;
        const Res = this.FixedTimeList.findIndex(findBooking);
        if (Res > -1) {
            return true;
        }
        return false;
    }

    preCheckNode() {
        // resourceCategoryid - id
        // console.log(this.savedCategories);
        // console.log(this.treeControl.dataNodes);
        const repeatedCategory = this.currSelectedRess.map((resource) => {
            return this.treeControl.dataNodes.find((category) => category.id === resource.resourceCategoryid);
        });
        // console.log(repeatedCategory);
        const uniqueChars = [...new Set(repeatedCategory)].filter((resource) => !!resource?.id);
        // console.log(uniqueChars);

        uniqueChars.forEach((category) => {
            this.checklistSelection.select(category);
        });
        this.getResourcesByCategoriesAndSelectCurrent(uniqueChars);
    }

    ngOnDestroy(): void {
        this._unsubscribeAll$.next(true);
        this._unsubscribeAll$.complete();
    }
}

/**  Copyright 2019 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
